/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_vipUserRelationship = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbPcs_vipUserRelationship">;
    readonly " $refType": "PdpRespSidebarBlurbs_vipUserRelationship";
};
export type PdpRespSidebarBlurbs_vipUserRelationship$data = PdpRespSidebarBlurbs_vipUserRelationship;
export type PdpRespSidebarBlurbs_vipUserRelationship$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_vipUserRelationship$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_vipUserRelationship">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_vipUserRelationship",
      "args": null
    }
  ]
};
(node as any).hash = '1cf8265b48aa8d1f45d27e1f5bfad332';
export default node;
